<template>
  <v-content>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <h1 class="titulos">Reservas realizadas</h1>
            <v-data-table
              :headers="headers"
              :items="items"
              hide-actions
              :pagination.sync="pagination"
              class="elevation-1"
            >
              <template slot="items" slot-scope="props">
                <td>{{ dateFormat(props.item.date) }}</td>
                <td>{{ hourFormat(props.item.Hour.start_time) }}</td>
                <td>{{ hourFormat(props.item.Hour.end_time) }}</td>
                <td>{{ props.item.Resource.name }}</td>
                <td>{{ props.item.User.name }}</td>
                <td class="justify-center px-0">
                  <v-btn icon class="mx-0" @click="openConfirmDialog(props.item.id)">
                    <v-icon color="error">delete</v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          <div class="text-xs-center pt-2">
            <v-pagination v-model="pagination.page" :length="pages"></v-pagination>
          </div>
          <v-snackbar
            :timeout=6000
            :color="color"
            :multi-line="'multi-line'"
            v-model="snackbar">
            <v-icon dark>error_outline</v-icon>
            {{ error }}
            <v-btn dark flat @click.native="snackbar = false">Cerrar</v-btn>
          </v-snackbar>
        </v-flex>
        <confirm ref="confirm"></confirm>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
/* eslint-disable */
  import Shared from '@/services/Shared';
  import moment from 'moment'
  import Confirm from '@/components/dialogs/Confirm.vue'

  export default {
    data() {
      return {
        items: [],
        headers: [
          {text: 'Fecha', value: 'date'},
          {text: 'Hora inicio', value: 'start_time'},
          {text: 'Hora fin', value: 'date'},
          {text: 'Recurso', value: 'resource'},
          {text: 'Usuario', value: 'user'},
          { text: 'Acciones', value: 'actions', sortable: false, align: 'center' }
        ],
        pagination: {
          rowsPerPage: 10
        },
        error: null,
        snackbar: false,
        color: ''
      }
    },
    created() {
      this.reservations()
    },
    methods: {
      async reservations() {
        try {
          const response = await Shared.reservations()
          this.items = response.data.data
        } catch (err) {
          console.log(err)
        }
      },
      dateFormat: function (date) {
        return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
      },
      hourFormat: function (hour) {
        return moment(hour, 'HH:mm:SS').format('HH:mm')
      },
      navigateTo(route) {
        this.$router.push(route)
      },
      openConfirmDialog(id){
        this.$refs.confirm.open('Eliminar', '¿Desea eliminar la reserva?', { color: 'error' }).then((confirm) => {
          if(confirm){
            this.deleteReservation(id)
          }
        });
      },
      async deleteReservation(id){
        try{
          const response = await Shared.deleteReservation({
            id: id
          });
          this.error = response.data.msg;
          this.snackbar = true;
          this.color = 'success';
          this.reservations()
        }catch(err){
          this.error = err.response.data.msg;
          this.snackbar = true;
          this.color = 'error';
        }
      },
    },
    computed: {
      pages() {
        if (this.pagination.rowsPerPage == null ||
          this.pagination.totalItems == null
        ) return 0

        return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
      }
    },
    components: {
      Confirm
    }
  };
</script>


<style scoped>
  .z {
    z-index: 1
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/Admin.vue